import React, { FunctionComponent } from 'react';
import styles from './styles.module.scss';

export const OffAir: FunctionComponent = () => {
  return <div className={styles['off-air']}>Off Air</div>;
};
